import React from 'react';
import RegisterForm from '../../components/auth/RegisterForm';

const RegisterPage: React.FC = () => {
  return (
    <div className="flex min-h-screen bg-white">
      <div className="flex items-center justify-center flex-1 p-4">
        <RegisterForm />
      </div>
      
      <div className="hidden lg:block w-1/2 bg-primary p-12 flex flex-col justify-center items-center">
        <div className="text-white text-center space-y-6">
          <h2 className="text-4xl font-bold">Start Your Chinese Journey</h2>
          <p className="text-lg text-white/90">
            Create your account and begin learning Chinese today with our interactive platform
          </p>
          <ul className="mt-8 space-y-4">
            <li className="flex items-center space-x-3">
              <span className="text-2xl">🔍</span>
              <span>Personalized Learning Path</span>
            </li>
            <li className="flex items-center space-x-3">
              <span className="text-2xl">🎓</span>
              <span>HSK Level Evaluation</span>
            </li>
            <li className="flex items-center space-x-3">
              <span className="text-2xl">📊</span>
              <span>Progress Tracking</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
